import { DATE_FORMAT } from '@/main.config'
import { nowMoment } from '@/mixins/now-moment'

export const courseDate = {
  mixins: [nowMoment],
  computed: {
    courseMomentStartDate() {
      if (!this.course) {
        return null
      }
      return this.getCourseMomentStartDate(this.course)
    },
    courseMomentEndDate() {
      if (!this.course || !this.course.close_date) {
        return null
      }
      return this.getCourseMomentEndDate(this.course)
    },
    courseFormattedStartDate() {
      if (!this.courseMomentStartDate) {
        return null
      }
      return this.courseMomentStartDate.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
    },
    courseFormattedEndDate() {
      if (!this.courseMomentEndDate) {
        return null
      }
      return this.courseMomentEndDate.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
    },
    isCourseEndBeforeNow() {
      if (!this.courseMomentEndDate) {
        return false
      }
      return this.nowMoment.isAfter(this.courseMomentEndDate, 'day')
    }
  },
  methods: {
    getCourseMomentStartDate(course) {
      return this.moment.utc(course.start_date, DATE_FORMAT.server).local()
    },
    getCourseMomentEndDate(course) {
      if (!course.close_date) {
        return null
      }
      return this.moment.utc(course.close_date, DATE_FORMAT.server).local()
    },
    getCourseFormattedStartDate(course) {
      return this.getCourseMomentStartDate(course).format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
    },
    getCourseFormattedEndDate(course) {
      const endDate = this.getCourseMomentEndDate(course)
      if (!endDate) {
        return null
      }
      return endDate.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
    }
  }
}
